<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { Locales, ProjectModuleDto } from '@/services/types/api.types';
import { useConfigurationStore } from '@/stores/configurations.store';
import LocalizedInput from '../LocalizedInput.vue';
import StandardToggle from '../StandardToggle.vue';

// CONST
const { t } = useI18n();
const isProjectTOCEnabled = useConfigurationStore().isFeatureEnabled('projectTOC');

// PROPS
const props = defineProps<{
  languageEnabled: Locales[];
  editLocale: Locales;
  module: ProjectModuleDto;
}>();
</script>
<template>
  <div class="module-subscription">
    <localized-input
      name="title"
      :label="t('global.label.title')"
      :editLocale="editLocale"
      outlined
      :language_enabled="props.languageEnabled"
    />
    <standard-toggle
      v-if="isProjectTOCEnabled"
      name="config.includeInTableOfContents"
      :label="t('project-module.admin.includeInTableOfContents')"
      outlined
    />
  </div>
</template>
